/* EN Carousel bar：.en-carousel-bar[data-for] を見つけて、対応する横スクロール要素と結びつける。
   同じファイルが複数回読み込まれても一度しか動かない。 */
(function () {
  if (window.enCarouselReady) return;
  window.enCarouselReady = true;

  function init(bar) {
    var el = document.getElementById(bar.getAttribute('data-for'));
    if (!el) return;
    var fill = bar.querySelector('.en-carousel-bar__fill');
    var cur = bar.querySelector('[data-cur]');
    var prev = bar.querySelector('[data-dir="-1"]');
    var next = bar.querySelector('[data-dir="1"]');

    function items() {
      return Array.prototype.filter.call(el.children, function (c) { return c.offsetParent !== null; });
    }
    function step() {
      var list = items();
      if (list.length < 2) return el.clientWidth;
      return list[1].offsetLeft - list[0].offsetLeft;
    }
    function update() {
      var max = el.scrollWidth - el.clientWidth;
      var list = items();
      var s = step();
      var i = s > 0 ? Math.round(el.scrollLeft / s) : 0;
      i = Math.max(0, Math.min(list.length - 1, i));
      cur.textContent = ('0' + (i + 1)).slice(-2);
      var pct = max > 0 ? ((el.scrollLeft + el.clientWidth) / el.scrollWidth) * 100 : 100;
      fill.style.transform = 'translateX(' + (pct - 100) + '%)';
      if (el.scrollLeft > 16) bar.classList.add('is-moved');
      prev.disabled = el.scrollLeft <= 2;
      next.disabled = el.scrollLeft >= max - 2;
    }

    var raf = null;
    el.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    [prev, next].forEach(function (btn) {
      btn.addEventListener('click', function () {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        el.scrollBy({ left: step() * Number(btn.getAttribute('data-dir')), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    update();
  }

  function all() {
    document.querySelectorAll('.en-carousel-bar:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '');
      init(bar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  /* テーマエディタでセクションを再描画したときにも拾う */
  document.addEventListener('shopify:section:load', all);
})();
